/* eslint-disable comma-dangle */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'KeyDateItemBlock';
const CLS = 'keyDateItemBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/keyDateItemBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import moment from 'moment';

export class KeyDateItemBlock {
	constructor($el) {
		// $el is the widget node return by the loadKeyDateItemBlock function
		this.$el = $el;
	}

	init() {
		this.setKeyDateItemBlock();
	}

	setKeyDateItemBlock() {
		// Add Some logic here
		const This = this;
		const $wg = $(this.$el);
		let keyDate = $wg.data('keyDate');
		let todayMoment = moment.utc();
		let keyDateMoment = moment(keyDate, 'DD-MM-YYYY');
		let day = keyDateMoment.format('DD');
		let month = keyDateMoment.format('MMM');
		let year = keyDateMoment.format('YYYY');
		$wg.find(WG + 'date').html(`
			<div>${day}</div>
			<div>${month}</div>
			<div>${year}</div>
		`);

		// check if it has passed
		if (todayMoment.isSameOrAfter(keyDateMoment)) {
			$wg.addClass('is-reached');
		}
	}

	// Add more functions like on above here
}
